
import { Component, Vue } from "vue-property-decorator";
import { commonModule, installationsModule } from "@/store/modules/store-accessor";
import QuickAddClient from "@/components/Modals/QuickAdd/QuickAddClient.vue";
import QuickAddInstallation from "@/components/Modals/QuickAdd/QuickAddInstallation.vue";
import QuickAddOffer from "@/components/Modals/QuickAdd/QuickAddOffer.vue";

@Component({ components: { QuickAddClient, QuickAddInstallation, QuickAddOffer } })
export default class QuickAddOfferModal extends Vue {
  wizardStep = 1;
  client = { id: -1, firstname: "", lastname: "", entity_name: "", is_business: false };
  installation = { id: -1, address: "", area: "", zip_code: "", floor: 0 };

  get clientName() {
    return this.client.is_business
      ? `${this.client.entity_name} (${this.client.firstname} ${this.client.lastname})`
      : `${this.client.firstname} ${this.client.lastname}`;
  }

  get installationAddress() {
    return [this.installation.address, this.installation.area, this.installation.zip_code, this.installation.floor]
      .filter(Boolean)
      .join(", ");
  }

  mounted() {
    commonModule.initSnackbar({});
  }

  doClose() {
    commonModule.hideModal();
    installationsModule.clearNewInstallationCoordinates();
  }

  doNextStep(value: any) {
    if (this.wizardStep === 1) this.client = value;
    if (this.wizardStep === 2) this.installation = value;
    this.wizardStep += 1;
  }

  doPrevStep() {
    if (this.wizardStep <= 1) return;
    this.wizardStep -= 1;
    if (this.wizardStep === 1) {
      this.client = { id: -1, firstname: "", lastname: "", entity_name: "", is_business: false };
    }
    if (this.wizardStep === 2) {
      this.installation = { id: -1, address: "", area: "", zip_code: "", floor: 0 };
    }
  }
}
